<template>
	<div class="main-content">
		<ss-header />
		<router-view />
		<ss-footer />
	</div>
</template>

<script>
	import ssHeader from '../components/ss-header/ss-header.vue'
	import ssFooter from '../components/ss-footer/ss-footer.vue'
	export default {
		components: {
			ssHeader, ssFooter
		}
	}
	
</script>

<style lang="scss">
	.main-content{
		
	}
</style>
